import React from 'react';

const StudioCanvasArea = ({ children }) => (
  <section className="studio-canvas">
    {children || <div className="studio-canvas-placeholder">Canvas Area</div>}
  </section>
);

export default StudioCanvasArea;
